module.exports = __webpack_public_path__ + "img/gide_logo.5f162307.png";